interface State {
  stripe: boolean
  registration: {
    clinicChains: string[]
  }
  clinicChain: Record<string, {
    exclude: {
      suppliers: string[]
    }
  }>
}

export const useFeatureSettingsStore = defineStore('feature-settings', () => {
  const { baseURL } = useRuntimeConfig().app
  const {
    data: settings,
    pending: isFeatureSettingsDataPending,
    refresh: reloadFeatureSettingsData,
  } = useFetch<State>('/api/feature-settings/', { baseURL })

  function $reset() {
    reloadFeatureSettingsData()
  }

  return {
    isFeatureSettingsDataPending,
    reloadFeatureSettingsData,
    $reset,
    settings,
  }
})
